import * as types from "../mutation-types";

const state = {
	open: false,
	notificationText: ""
};

const getters = {
	open: state => state.open,
	notificationText: state => state.notificationText
};

const actions = {
	showNotification({ commit }, notificationText) {
		commit(types.SHOW_NOTIFICATION, notificationText);
	},
	closeNotification({ commit }) {
		commit(types.CLOSE_NOTIFICATION);
	}
};

const mutations = {
	[types.SHOW_NOTIFICATION](state, { notificationText }) {
		state.open = true;
		state.notificationText = notificationText;
	},
	[types.CLOSE_NOTIFICATION](state) {
		state.open = false;
		state.notificationText = "";
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/notification.js